// extracted by mini-css-extract-plugin
module.exports = {"videoDescription":"VideoDescription_videoDescription__3m2BT","showMoreButton":"VideoDescription_showMoreButton__1psnd"};